import { useState, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Achievement } from '@ai-platform/utils';

import { AchievementsModalOptions, ModalContextValue } from '../ModalContext.types';

type UseAchivementModalType = ModalContextValue['achievement'] & AchievementsModalOptions;

const achivementParam = 'achievement';

export const useAchievementModal = (): UseAchivementModalType => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [isOpen, setOpen] = useState(false);
    const [achievementId, setAchievementId] = useState<Achievement['id'] | null>(null);

    const open = useCallback((options?: AchievementsModalOptions) => {
        setAchievementId(options?.achievementId ?? null);
        setOpen(true);
    }, []);

    const close = useCallback(() => setOpen(false), []);

    useEffect(() => {
        const achievementId = searchParams.get(achivementParam);

        if (!achievementId) {
            return;
        }

        setAchievementId(achievementId);
        setOpen(true);

        searchParams.delete(achivementParam);
        setSearchParams(searchParams, { replace: true });
    }, [searchParams, setSearchParams]);

    return { isOpen, open, close, achievementId };
};
